// Content wird erst eingeblendet, wenn das DOM aufgebaut ist

$(window).on('load', function(){ 
    $('.skeleton-container').hide()
    $('.container').fadeIn()
    console.log("loaded")
});
